import { useFormik } from 'formik';
import { addAnomalyPayload } from '@shared';

export function useAnomaliesFormik(
  addAnomaly: (a: addAnomalyPayload) => void,
  currentRegion: { start: number; end: number; uuid: string }
) {
  return useFormik({
    initialValues: {
      id: 11,
      comment: '',
    },
    onSubmit: ({ id, comment }, { resetForm }) => {
      addAnomaly({ id, comment, startOffset: currentRegion.start, regionUuid: currentRegion.uuid });
      resetForm();
    },
  });
}
